var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3407 31.3418C10.5226 31.3418 5.21055 28.4572 2.30155 23.6494C-0.607454 18.9018 -0.607454 13.0724 2.30155 8.26465C5.21055 3.51701 10.5226 0.572266 16.3407 0.572266C22.0954 0.572266 27.4075 3.51701 30.3165 8.26465C33.2255 13.0724 33.2255 18.9018 30.3165 23.6494C27.4075 28.4572 22.0954 31.3418 16.3407 31.3418ZM22.4749 12.1108L20.388 10.1276L16.3407 13.9738L12.2933 10.1276L10.1432 12.1108L14.1905 15.957L10.1432 19.8032L12.2933 21.8465L16.3407 18.0003L20.388 21.8465L22.4749 19.8032L18.4276 15.957L22.4749 12.1108Z",
    fill: "#F30000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedClose);
export default __webpack_public_path__ + "static/media/red_close.5b4284563dcef7f540d855553dc8acaf.svg";
export { ForwardRef as ReactComponent };